export const APP_IDENTIFIER = 'date-fields-settings';
export const APP_TEAM_NAME = 'jsm-shield';
export const APP_SOURCE_NAME = 'dateFieldsSettings';
export const APP_BOUNDARY_ID = 'jira.board-settings.cmp.dateFields';

export const APP_CMP_METRIC_KEY = `software.cmp.boards.${APP_IDENTIFIER}`;
